import { computed, ref } from '@vue/composition-api'

import store from '@/store'

export default function useTransactionTypes(ctx) {
  const tableColumns = [
    { key: 'code' },
    { key: 'label' },
    { key: 'slug' },
    { key: 'description' },
    { key: 'visible_credit_list', label: 'Visible Credit' },
    { key: 'visible_debit_list', label: 'Visible Debit' },
    { key: 'Actions' },
  ]

  const transactionTypes = computed(() => store.getters['transactionTypes/getTransactionTypes'])

  const transactionTypesLoading = ref(false)
  const fetchTransactionTypes = async () => {
    try {
      transactionTypesLoading.value = true
      await store.dispatch('transactionTypes/fetchTransactionTypes')
    } catch (error) {
      console.log(error)
    } finally {
      transactionTypesLoading.value = false
    }
  }
  const goToEditType = item => {
    ctx.root.$router.push(`/transaction-types/${item.id}`)
    ctx.root.$store.commit('transactionTypes/SET_TRANSACTION_TYPE_INFO', item)
  }
  fetchTransactionTypes()

  return {
    tableColumns,
    transactionTypes,
    transactionTypesLoading,
    fetchTransactionTypes,
    goToEditType,
  }
}
